// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Error_Class from "../Control.Monad.Error.Class/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Control_Monad_Reader_Trans from "../Control.Monad.Reader.Trans/index.js";
import * as Control_Monad_ST_Internal from "../Control.Monad.ST.Internal/index.js";
import * as Control_Plus from "../Control.Plus/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Array_ST from "../Data.Array.ST/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Lazy from "../Data.Lazy/index.js";
import * as Data_List from "../Data.List/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Foliage_Common from "../Foliage.Common/index.js";
import * as Foliage_Example_Library from "../Foliage.Example.Library/index.js";
import * as Foliage_Program from "../Foliage.Program/index.js";
import * as Halogen_HTML_Core from "../Halogen.HTML.Core/index.js";
import * as Halogen_HTML_Elements from "../Halogen.HTML.Elements/index.js";
import * as Partial_Unsafe from "../Partial.Unsafe/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var append_render = /* #__PURE__ */ Foliage_Program.append_render(Foliage_Program["_Render_Htmls"]);
var append_render1 = /* #__PURE__ */ Foliage_Program.append_render(Foliage_Program["_Render_RenderM_Htmls"]);
var mempty = /* #__PURE__ */ Data_Monoid.mempty(/* #__PURE__ */ Control_Monad_Reader_Trans.monoidReaderT(Data_Identity.applicativeIdentity)(Data_Monoid.monoidArray));
var append_render2 = /* #__PURE__ */ Foliage_Program.append_render(Foliage_Program["_Render_Term"]);
var show = /* #__PURE__ */ Data_Show.show(/* #__PURE__ */ Foliage_Program["_Show_Term"](Foliage_Program["_Eq_Show"]));
var append_render3 = /* #__PURE__ */ Foliage_Program.append_render(Foliage_Program["_Render_Lit"]);
var bind = /* #__PURE__ */ Control_Bind.bind(/* #__PURE__ */ Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity));
var $$void = /* #__PURE__ */ Data_Functor["void"](Control_Monad_ST_Internal.functorST);
var show1 = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var mempty1 = /* #__PURE__ */ Data_Monoid.mempty(Data_List_Types.monoidList);
var eq = /* #__PURE__ */ Data_Eq.eq(Foliage_Program["_Eq_FixedName"]);
var compare = /* #__PURE__ */ Data_Ord.compare(Data_Ord.ordString);
var monadExceptT = /* #__PURE__ */ Control_Monad_Except_Trans.monadExceptT(Data_Identity.monadIdentity);
var plusMap = /* #__PURE__ */ Data_Map_Internal.plusMap(Foliage_Program["_Ord_VarName"]);
var monadThrowExceptT = /* #__PURE__ */ Control_Monad_Except_Trans.monadThrowExceptT(monadExceptT);
var show2 = /* #__PURE__ */ Data_Show.show(Data_Show.showString);
var compare1 = /* #__PURE__ */ Data_Ord.compare(Data_Ord.ordInt);
var fromFoldable = /* #__PURE__ */ Data_Map_Internal.fromFoldable(Foliage_Program["_Ord_FixedName"])(Data_Foldable.foldableArray);
var fromFoldable1 = /* #__PURE__ */ Data_List.fromFoldable(Data_Foldable.foldableArray);
var type_Arr = function (α) {
    return function (β) {
        return Foliage_Example_Library.pair(α)(β);
    };
};
var term_Var = function (n) {
    return Foliage_Example_Library.left(Foliage_Example_Library.left(n));
};
var term_Lam = function (b) {
    return Foliage_Example_Library.left(Foliage_Example_Library.right(b));
};
var term_App = function (f) {
    return function (b) {
        return Foliage_Example_Library.right(Foliage_Example_Library.pair(f)(b));
    };
};
var render_Type = function (v) {
    if (v instanceof Foliage_Program.PairTerm) {
        return append_render([ Halogen_HTML_Core.text("(") ])(append_render1(render_Type(v.value0))(append_render([ Halogen_HTML_Core.text("\u2192") ])(append_render1(render_Type(v.value1))(append_render([ Halogen_HTML_Core.text(")") ])(mempty)))));
    };
    if (v instanceof Foliage_Program.VarTerm) {
        return append_render2(v)(mempty);
    };
    return Partial_Unsafe.unsafeCrashWith("invalid Type: " + show(v));
};
var render_Term = function (v) {
    if (v instanceof Foliage_Program.LeftTerm && (v.value0 instanceof Foliage_Program.LeftTerm && v.value0.value0 instanceof Foliage_Program.LiteralTerm)) {
        return append_render3("@" + v.value0.value0.value0)(mempty);
    };
    if (v instanceof Foliage_Program.LeftTerm && (v.value0 instanceof Foliage_Program.LeftTerm && v.value0.value0 instanceof Foliage_Program.VarTerm)) {
        return append_render2(v.value0.value0)(mempty);
    };
    if (v instanceof Foliage_Program.LeftTerm && v.value0 instanceof Foliage_Program.RightTerm) {
        return append_render([ Halogen_HTML_Core.text("\u03bb") ])(append_render1(render_Term(v.value0.value0))(mempty));
    };
    if (v instanceof Foliage_Program.RightTerm && v.value0 instanceof Foliage_Program.PairTerm) {
        return append_render([ Halogen_HTML_Core.text("(") ])(append_render1(render_Term(v.value0.value0))(append_render1(render_Term(v.value0.value1))(append_render([ Halogen_HTML_Core.text(")") ])(mempty))));
    };
    if (v instanceof Foliage_Program.VarTerm) {
        return append_render2(v)(mempty);
    };
    return Partial_Unsafe.unsafeCrashWith("invalid Term: " + show(v));
};
var render_Context = function (v) {
    if (v instanceof Foliage_Program.LeftTerm) {
        return append_render([ Halogen_HTML_Core.text("\u2205") ])(mempty);
    };
    if (v instanceof Foliage_Program.RightTerm && v.value0 instanceof Foliage_Program.PairTerm) {
        return append_render1(render_Type(v.value0.value0))(append_render([ Halogen_HTML_Core.text(",") ])(append_render1(render_Context(v.value0.value1))(mempty)));
    };
    if (v instanceof Foliage_Program.VarTerm) {
        return append_render2(v)(mempty);
    };
    return Partial_Unsafe.unsafeCrashWith("invalid Context: " + show(v));
};
var prop_Typed_term = function (v) {
    return Foliage_Example_Library.pair(Foliage_Example_Library.pair(Foliage_Example_Library.pair(v.i0)(v.i1))(v.tm))(Foliage_Example_Library.pair(v.ctx)(v.ty));
};
var prop_Parsed_term = function (v) {
    return Foliage_Example_Library.pair(Foliage_Example_Library.pair(v.i0)(v.i1))(v.tm);
};
var name_Var = "Var";
var name_Typed = "Typed";
var prop_Typed = /* #__PURE__ */ (function () {
    var $166 = Foliage_Program.Prop.create(name_Typed);
    return function ($167) {
        return $166(prop_Typed_term($167));
    };
})();
var name_Type = "Type";
var name_Term = "Term";
var name_Parsed = "Parsed";
var prop_Parsed = /* #__PURE__ */ (function () {
    var $168 = Foliage_Program.Prop.create(name_Parsed);
    return function ($169) {
        return $168(prop_Parsed_term($169));
    };
})();
var name_Context = "Context";
var lty_Var = /* #__PURE__ */ (function () {
    return new Foliage_Program.NamedLatticeType(name_Var);
})();
var lty_Type = /* #__PURE__ */ (function () {
    return new Foliage_Program.NamedLatticeType(name_Type);
})();
var ltyd_Type = /* #__PURE__ */ (function () {
    return new Data_Tuple.Tuple(name_Type, new Foliage_Program.LatticeTypeDef(Foliage_Example_Library.prod12(lty_Type)(lty_Type)));
})();
var lty_Term = /* #__PURE__ */ (function () {
    return new Foliage_Program.NamedLatticeType(name_Term);
})();
var lty_Symbol = /* #__PURE__ */ (function () {
    return new Foliage_Program.NamedLatticeType("Symbol");
})();
var lty_String = /* #__PURE__ */ (function () {
    return new Foliage_Program.NamedLatticeType("String");
})();
var ltyd_Symbol = /* #__PURE__ */ (function () {
    return new Data_Tuple.Tuple("Symbol", new Foliage_Program.LatticeTypeDef(new Foliage_Program.FlatLatticeType(lty_String)));
})();
var lty_Int = /* #__PURE__ */ (function () {
    return new Foliage_Program.NamedLatticeType("Int");
})();
var ltyd_Index = /* #__PURE__ */ (function () {
    return new Data_Tuple.Tuple("Index", new Foliage_Program.LatticeTypeDef(new Foliage_Program.FlatLatticeType(lty_Int)));
})();
var lty_Index = /* #__PURE__ */ (function () {
    return new Foliage_Program.NamedLatticeType("Index");
})();
var ltyd_Term = /* #__PURE__ */ (function () {
    return new Data_Tuple.Tuple(name_Term, new Foliage_Program.LatticeTypeDef(Foliage_Example_Library.sumLir(Foliage_Example_Library.sumLir(lty_Index)(lty_Term))(Foliage_Example_Library.prod12(lty_Term)(lty_Term))));
})();
var relation_Parsed = /* #__PURE__ */ (function () {
    return new Data_Tuple.Tuple(name_Parsed, new Foliage_Program.Relation({
        domain: Foliage_Example_Library.prod12(Foliage_Example_Library.prod12(lty_Index)(lty_Index))(lty_Term),
        render: function (v) {
            if (v instanceof Foliage_Program.PairTerm && v.value0 instanceof Foliage_Program.PairTerm) {
                return bind(append_render2(v.value0.value0)(mempty))(function (i01) {
                    return bind(append_render2(v.value0.value1)(mempty))(function (i11) {
                        return append_render([ Halogen_HTML_Elements.sub_(i01) ])(append_render1(render_Term(v.value1))(append_render([ Halogen_HTML_Elements.sub_(i11) ])(mempty)));
                    });
                });
            };
            return Partial_Unsafe.unsafeCrashWith("invalid Typed term: " + show(v));
        },
        canonical_term: prop_Parsed_term({
            i0: new Foliage_Program.VarTerm(Foliage_Program.newVarName("i0")),
            i1: new Foliage_Program.VarTerm(Foliage_Program.newVarName("i1")),
            tm: new Foliage_Program.VarTerm(Foliage_Program.newVarName("a")),
            ctx: new Foliage_Program.VarTerm(Foliage_Program.newVarName("\u0393")),
            ty: new Foliage_Program.VarTerm(Foliage_Program.newVarName("\u03b1"))
        })
    }));
})();
var lty_Context = /* #__PURE__ */ (function () {
    return new Foliage_Program.NamedLatticeType(name_Context);
})();
var ltyd_Context = /* #__PURE__ */ (function () {
    return new Data_Tuple.Tuple(name_Context, new Foliage_Program.LatticeTypeDef(Foliage_Example_Library.sumLir(Foliage_Program.UnitLatticeType.value)(Foliage_Example_Library.prod12(lty_Type)(lty_Context))));
})();
var relation_Typed = /* #__PURE__ */ (function () {
    return new Data_Tuple.Tuple(name_Typed, new Foliage_Program.Relation({
        domain: Foliage_Example_Library.prod12(Foliage_Example_Library.prod12(Foliage_Example_Library.prod12(lty_Index)(lty_Index))(lty_Term))(Foliage_Example_Library.prod12(lty_Context)(lty_Type)),
        render: function (v) {
            if (v instanceof Foliage_Program.PairTerm && (v.value0 instanceof Foliage_Program.PairTerm && (v.value0.value0 instanceof Foliage_Program.PairTerm && v.value1 instanceof Foliage_Program.PairTerm))) {
                return bind(append_render2(v.value0.value0.value0)(mempty))(function (i01) {
                    return bind(append_render2(v.value0.value0.value1)(mempty))(function (i11) {
                        return append_render1(render_Context(v.value1.value0))(append_render([ Halogen_HTML_Core.text("\u22a2") ])(append_render([ Halogen_HTML_Elements.sub_(i01) ])(append_render1(render_Term(v.value0.value1))(append_render([ Halogen_HTML_Elements.sub_(i11) ])(append_render([ Halogen_HTML_Core.text(":") ])(append_render1(render_Type(v.value1.value1))(mempty)))))));
                    });
                });
            };
            return Partial_Unsafe.unsafeCrashWith("invalid Typed term: " + show(v));
        },
        canonical_term: prop_Typed_term({
            i0: new Foliage_Program.VarTerm(Foliage_Program.newVarName("i0")),
            i1: new Foliage_Program.VarTerm(Foliage_Program.newVarName("i1")),
            tm: new Foliage_Program.VarTerm(Foliage_Program.newVarName("a")),
            ctx: new Foliage_Program.VarTerm(Foliage_Program.newVarName("\u0393")),
            ty: new Foliage_Program.VarTerm(Foliage_Program.newVarName("\u03b1"))
        })
    }));
})();
var dtyd_String = /* #__PURE__ */ (function () {
    return new Data_Tuple.Tuple("String", new Foliage_Program.ExternalDataTypeDef("String"));
})();
var dtyd_Int = /* #__PURE__ */ (function () {
    return new Data_Tuple.Tuple("Int", new Foliage_Program.ExternalDataTypeDef("Int"));
})();
var dty_String = /* #__PURE__ */ (function () {
    return new Foliage_Program.NamedDataType("String");
})();
var dty_Int = /* #__PURE__ */ (function () {
    return new Foliage_Program.NamedDataType("Int");
})();
var context_Nil = /* #__PURE__ */ (function () {
    return Foliage_Example_Library.left(Foliage_Program.UnitTerm.value);
})();
var context_Cons = function (α) {
    return function (γ) {
        return Foliage_Example_Library.right(Foliage_Example_Library.pair(α)(γ));
    };
};
var compileInput = function (tm_) {
    return (function __do() {
        var i_ref = {
            value: 0
        };
        var rules_ref = Data_Array_ST["new"]();
        var next_i = function __do() {
            $$void(Control_Monad_ST_Internal.modify(function (v) {
                return 1 + v | 0;
            })(i_ref))();
            return i_ref.value;
        };
        var go = function (tm) {
            if (tm instanceof Foliage_Program.LeftTerm && (tm.value0 instanceof Foliage_Program.LeftTerm && tm.value0.value0 instanceof Foliage_Program.LiteralTerm)) {
                return function __do() {
                    var i0 = next_i();
                    var i1 = next_i();
                    return $$void(Data_Array_ST.push(new Data_Tuple.Tuple("@" + (tm.value0.value0.value0 + (" " + ("[" + (show1(i0) + ("\u2192" + (show1(i1) + "]")))))), new Foliage_Program.Rule({
                        hypotheses: mempty1,
                        conclusion: prop_Parsed({
                            i0: new Foliage_Program.LiteralTerm(show1(i0), dty_Int),
                            i1: new Foliage_Program.LiteralTerm(show1(i1), dty_Int),
                            tm: tm
                        })
                    })))(rules_ref))();
                };
            };
            if (tm instanceof Foliage_Program.LeftTerm && tm.value0 instanceof Foliage_Program.RightTerm) {
                return function __do() {
                    var i0 = next_i();
                    go(tm.value0.value0)();
                    var i1 = next_i();
                    return $$void(Data_Array_ST.push(new Data_Tuple.Tuple("\u03bb" + (" " + ("[" + (show1(i0) + ("\u2192" + (show1(i1) + "]"))))), new Foliage_Program.Rule({
                        hypotheses: mempty1,
                        conclusion: prop_Parsed({
                            i0: new Foliage_Program.LiteralTerm(show1(i0), dty_Int),
                            i1: new Foliage_Program.LiteralTerm(show1(i1), dty_Int),
                            tm: tm
                        })
                    })))(rules_ref))();
                };
            };
            if (tm instanceof Foliage_Program.RightTerm && tm.value0 instanceof Foliage_Program.PairTerm) {
                return function __do() {
                    var i0 = next_i();
                    go(tm.value0.value0)();
                    go(tm.value0.value1)();
                    var i1 = next_i();
                    return $$void(Data_Array_ST.push(new Data_Tuple.Tuple("app" + (" " + ("[" + (show1(i0) + ("\u2192" + (show1(i1) + "]"))))), new Foliage_Program.Rule({
                        hypotheses: mempty1,
                        conclusion: prop_Parsed({
                            i0: new Foliage_Program.LiteralTerm(show1(i0), dty_Int),
                            i1: new Foliage_Program.LiteralTerm(show1(i1), dty_Int),
                            tm: tm
                        })
                    })))(rules_ref))();
                };
            };
            return Partial_Unsafe.unsafeCrashWith("invalid input Term: " + show(tm));
        };
        go(tm_)();
        var rules = Data_Array_ST.freeze(rules_ref)();
        return rules;
    })();
};
var compare_String = function (dictApplicative) {
    var pure1 = Control_Applicative.pure(dictApplicative);
    return function (dictPlus) {
        var empty = Control_Plus.empty(dictPlus);
        return function (dictMonadThrow) {
            var throwError = Control_Monad_Error_Class.throwError(dictMonadThrow);
            return function (dictShow) {
                var show3 = Data_Show.show(Foliage_Program["_Show_Term"](dictShow));
                return function (dictShow1) {
                    var show4 = Data_Show.show(Foliage_Program["_Show_Term"](dictShow1));
                    return new Foliage_Common.Opaque(Type_Proxy["Proxy"].value, function (v) {
                        if (v.value0 instanceof Foliage_Program.LiteralTerm && (v.value0.value1 instanceof Foliage_Program.NamedDataType && (v.value1 instanceof Foliage_Program.LiteralTerm && (v.value1.value1 instanceof Foliage_Program.NamedDataType && (eq(v.value0.value1.value0)("String") && eq(v.value1.value1.value0)("String")))))) {
                            return pure1(new Data_Tuple.Tuple(compare(v.value0.value0)(v.value1.value0), empty));
                        };
                        return throwError({
                            label: Foliage_Common["_error"],
                            source: "compare.String",
                            description: "inputs are not literal Strings: " + (show3(v.value0) + (", " + show4(v.value1)))
                        });
                    });
                };
            };
        };
    };
};
var ltyd_String = /* #__PURE__ */ (function () {
    return new Data_Tuple.Tuple("String", new Foliage_Program.ExternalLatticeTypeDef({
        name: "String",
        compare_impl: compare_String(Control_Monad_Except_Trans.applicativeExceptT(monadExceptT))(plusMap)(monadThrowExceptT)(Foliage_Program["_Eq_Show"])(Foliage_Program["_Eq_Show"])
    }));
})();
var compare_Int = function (dictBind) {
    var bind2 = Control_Bind.bind(dictBind);
    return function (dictMonadThrow) {
        var throwError = Control_Monad_Error_Class.throwError(dictMonadThrow);
        var pure1 = Control_Applicative.pure((dictMonadThrow.Monad0()).Applicative0());
        return function (dictPlus) {
            var empty = Control_Plus.empty(dictPlus);
            return function (dictShow) {
                var show3 = Data_Show.show(Foliage_Program["_Show_Term"](dictShow));
                return function (dictShow1) {
                    var show4 = Data_Show.show(Foliage_Program["_Show_Term"](dictShow1));
                    return new Foliage_Common.Opaque(Type_Proxy["Proxy"].value, function (v) {
                        if (v.value0 instanceof Foliage_Program.LiteralTerm && (v.value0.value1 instanceof Foliage_Program.NamedDataType && (v.value1 instanceof Foliage_Program.LiteralTerm && (v.value1.value1 instanceof Foliage_Program.NamedDataType && (eq(v.value0.value1.value0)("Int") && eq(v.value1.value1.value0)("Int")))))) {
                            return bind2(Data_Maybe.maybe(throwError({
                                label: Foliage_Common["_error"],
                                source: "compare.Int",
                                description: show2(v.value0.value0) + " is not an Int"
                            }))(pure1)(Data_Int.fromString(v.value0.value0)))(function (x1) {
                                return bind2(Data_Maybe.maybe(throwError({
                                    label: Foliage_Common["_error"],
                                    source: "compare.Int",
                                    description: show2(v.value1.value0) + " is not an Int"
                                }))(pure1)(Data_Int.fromString(v.value1.value0)))(function (x2) {
                                    return pure1(new Data_Tuple.Tuple(compare1(x1)(x2), empty));
                                });
                            });
                        };
                        return throwError({
                            label: Foliage_Common["_error"],
                            source: "compare.Int",
                            description: "inputs are not literal Ints: " + (show3(v.value0) + (", " + show4(v.value1)))
                        });
                    });
                };
            };
        };
    };
};
var ltyd_Int = /* #__PURE__ */ (function () {
    return new Data_Tuple.Tuple("Int", new Foliage_Program.ExternalLatticeTypeDef({
        name: "Int",
        compare_impl: compare_Int(Control_Monad_Except_Trans.bindExceptT(monadExceptT))(monadThrowExceptT)(plusMap)(Foliage_Program["_Eq_Show"])(Foliage_Program["_Eq_Show"])
    }));
})();
var example = /* #__PURE__ */ Data_Lazy.defer(function (v) {
    var v1 = new Data_Tuple.Tuple("((\u03bb \u03bb (@0 @1) \u03bb @0) \u03bb @0)", term_App(term_App(term_Lam(term_Lam(term_App(term_Var(new Foliage_Program.LiteralTerm("1", dty_Int)))(term_Var(new Foliage_Program.LiteralTerm("0", dty_Int))))))(term_Lam(term_Var(new Foliage_Program.LiteralTerm("0", dty_Int)))))(term_Lam(term_Var(new Foliage_Program.LiteralTerm("0", dty_Int)))));
    return new Foliage_Program.Module({
        name: "Typing . Simply-Typed Lambda Calculus",
        doc: new Data_Maybe.Just(Data_String_Common.trim("\x0aThis program implements type-inference for the following language:\x0a\x0a  \u03b1 ,        \u0393 \u22a2 @0 : \u03b1\x0a  \u03b1 , \u03b2 ,    \u0393 \u22a2 @1 : \u03b2\x0a  \u03b1 , \u03b2 , \u03b4, \u0393 \u22a2 @2 : \u03b4\x0a  \x0a  \u03b1, \u0393 \u22a2 b : \u03b2\x0a  \u2013\u2013\u2013\u2013\u2013\u2013\u2013\u2013\u2013\u2013\u2013\u2013\x0a  \u0393 \u22a2 \u03bb b : \u03b1 \u2192 \u03b2\x0a  \x0a  \u0393 \u22a2 f : \u03b1 \u2192 \u03b2\x0a  \u0393 \u22a2 a : \u03b1\x0a  \u2013\u2013\u2013\u2013\u2013\u2013\u2013\u2013\u2013\u2013\u2013\u2013\x0a  \u0393 \u22a2 f a : \u03b2\x0a\x0aNote that the language doesn't have type variables -- those arise in the implementation as meta-variables.\x0a\x0aParsed input: " + (v1.value0 + "\x0a"))),
        initialGas: 40,
        dataTypeDefs: fromFoldable([ dtyd_Int, dtyd_String ]),
        latticeTypeDefs: fromFoldable(Data_Array.concat([ [ ltyd_Int, ltyd_String, ltyd_Symbol, ltyd_Index ], [ ltyd_Term, ltyd_Type, ltyd_Context ] ])),
        functionDefs: fromFoldable([  ]),
        relations: fromFoldable([ relation_Parsed, relation_Typed ]),
        rules: fromFoldable(Data_Array.concat([ [ new Data_Tuple.Tuple("var 0", (function () {
            var ty = new Foliage_Program.VarTerm(Foliage_Program.newVarName("\u03b1"));
            var tm = term_Var(new Foliage_Program.LiteralTerm("0", dty_Int));
            var i1 = new Foliage_Program.VarTerm(Foliage_Program.newVarName("i1"));
            var i0 = new Foliage_Program.VarTerm(Foliage_Program.newVarName("i0"));
            var ctx = context_Cons(ty)(new Foliage_Program.VarTerm(Foliage_Program.newVarName("\u0393")));
            return new Foliage_Program.Rule({
                hypotheses: fromFoldable1([ new Foliage_Program.Hypothesis(prop_Parsed({
                    i0: i0,
                    i1: i1,
                    tm: tm
                }), [  ]) ]),
                conclusion: prop_Typed({
                    i0: i0,
                    i1: i1,
                    tm: tm,
                    ty: ty,
                    ctx: ctx
                })
            });
        })()), new Data_Tuple.Tuple("var 1", (function () {
            var β = new Foliage_Program.VarTerm(Foliage_Program.newVarName("\u03b2"));
            var α = new Foliage_Program.VarTerm(Foliage_Program.newVarName("\u03b1"));
            var tm = term_Var(new Foliage_Program.LiteralTerm("1", dty_Int));
            var i1 = new Foliage_Program.VarTerm(Foliage_Program.newVarName("i1"));
            var i0 = new Foliage_Program.VarTerm(Foliage_Program.newVarName("i0"));
            var ctx = context_Cons(β)(context_Cons(α)(new Foliage_Program.VarTerm(Foliage_Program.newVarName("\u0393"))));
            return new Foliage_Program.Rule({
                hypotheses: fromFoldable1([ new Foliage_Program.Hypothesis(prop_Parsed({
                    i0: i0,
                    i1: i1,
                    tm: tm
                }), [  ]) ]),
                conclusion: prop_Typed({
                    i0: i0,
                    i1: i1,
                    tm: tm,
                    ty: α,
                    ctx: ctx
                })
            });
        })()), new Data_Tuple.Tuple("var 2", (function () {
            var γ = new Foliage_Program.VarTerm(Foliage_Program.newVarName("\u03b3"));
            var β = new Foliage_Program.VarTerm(Foliage_Program.newVarName("\u03b2"));
            var α = new Foliage_Program.VarTerm(Foliage_Program.newVarName("\u03b1"));
            var tm = term_Var(new Foliage_Program.LiteralTerm("2", dty_Int));
            var i1 = new Foliage_Program.VarTerm(Foliage_Program.newVarName("i1"));
            var i0 = new Foliage_Program.VarTerm(Foliage_Program.newVarName("i0"));
            var ctx = context_Cons(γ)(context_Cons(β)(context_Cons(α)(new Foliage_Program.VarTerm(Foliage_Program.newVarName("\u0393")))));
            return new Foliage_Program.Rule({
                hypotheses: fromFoldable1([ new Foliage_Program.Hypothesis(prop_Parsed({
                    i0: i0,
                    i1: i1,
                    tm: tm
                }), [  ]) ]),
                conclusion: prop_Typed({
                    i0: i0,
                    i1: i1,
                    tm: tm,
                    ty: α,
                    ctx: ctx
                })
            });
        })()), new Data_Tuple.Tuple("lam", (function () {
            var β = new Foliage_Program.VarTerm(Foliage_Program.newVarName("\u03b2"));
            var α = new Foliage_Program.VarTerm(Foliage_Program.newVarName("\u03b1"));
            var i3 = new Foliage_Program.VarTerm(Foliage_Program.newVarName("i3"));
            var i2 = new Foliage_Program.VarTerm(Foliage_Program.newVarName("i2"));
            var i1 = new Foliage_Program.VarTerm(Foliage_Program.newVarName("i1"));
            var i0 = new Foliage_Program.VarTerm(Foliage_Program.newVarName("i0"));
            var ctx = new Foliage_Program.VarTerm(Foliage_Program.newVarName("\u0393"));
            var b = new Foliage_Program.VarTerm(Foliage_Program.newVarName("b"));
            return new Foliage_Program.Rule({
                hypotheses: fromFoldable1([ new Foliage_Program.Hypothesis(prop_Parsed({
                    i0: i0,
                    i1: i3,
                    tm: term_Lam(b)
                }), [  ]), new Foliage_Program.Hypothesis(prop_Typed({
                    i0: i1,
                    i1: i2,
                    tm: b,
                    ctx: context_Cons(α)(ctx),
                    ty: β
                }), [  ]) ]),
                conclusion: prop_Typed({
                    i0: i0,
                    i1: i3,
                    tm: term_Lam(b),
                    ty: type_Arr(α)(β),
                    ctx: ctx
                })
            });
        })()), new Data_Tuple.Tuple("app", (function () {
            var β = new Foliage_Program.VarTerm(Foliage_Program.newVarName("\u03b2"));
            var α = new Foliage_Program.VarTerm(Foliage_Program.newVarName("\u03b1"));
            var i5 = new Foliage_Program.VarTerm(Foliage_Program.newVarName("i5"));
            var i4 = new Foliage_Program.VarTerm(Foliage_Program.newVarName("i4"));
            var i3 = new Foliage_Program.VarTerm(Foliage_Program.newVarName("i3"));
            var i2 = new Foliage_Program.VarTerm(Foliage_Program.newVarName("i2"));
            var i1 = new Foliage_Program.VarTerm(Foliage_Program.newVarName("i1"));
            var i0 = new Foliage_Program.VarTerm(Foliage_Program.newVarName("i0"));
            var f = new Foliage_Program.VarTerm(Foliage_Program.newVarName("f"));
            var ctx = new Foliage_Program.VarTerm(Foliage_Program.newVarName("\u0393"));
            var a = new Foliage_Program.VarTerm(Foliage_Program.newVarName("a"));
            return new Foliage_Program.Rule({
                hypotheses: fromFoldable1([ new Foliage_Program.Hypothesis(prop_Parsed({
                    i0: i0,
                    i1: i5,
                    tm: term_App(f)(a)
                }), [  ]), new Foliage_Program.Hypothesis(prop_Typed({
                    i0: i1,
                    i1: i2,
                    tm: f,
                    ctx: ctx,
                    ty: type_Arr(α)(β)
                }), [  ]), new Foliage_Program.Hypothesis(prop_Typed({
                    i0: i3,
                    i1: i4,
                    tm: a,
                    ctx: ctx,
                    ty: α
                }), [  ]) ]),
                conclusion: prop_Typed({
                    i0: i0,
                    i1: i5,
                    tm: term_App(f)(a),
                    ty: β,
                    ctx: ctx
                })
            });
        })()) ], compileInput(v1.value1) ]))
    });
});
export {
    example,
    compileInput,
    relation_Parsed,
    prop_Parsed,
    prop_Parsed_term,
    relation_Typed,
    prop_Typed,
    prop_Typed_term,
    name_Var,
    name_Term,
    name_Context,
    name_Typed,
    name_Parsed,
    lty_Var,
    lty_Context,
    ltyd_Context,
    render_Context,
    context_Nil,
    context_Cons,
    lty_Type,
    ltyd_Type,
    render_Type,
    type_Arr,
    name_Type,
    lty_Int,
    dty_Int,
    lty_String,
    lty_Symbol,
    lty_Index,
    lty_Term,
    ltyd_Term,
    render_Term,
    term_Var,
    term_Lam,
    term_App,
    dty_String,
    dtyd_Int,
    ltyd_Int,
    compare_Int,
    dtyd_String,
    compare_String,
    ltyd_String,
    ltyd_Index,
    ltyd_Symbol
};
